import { z } from 'zod'

const validationschema = (t) => {
  const emailRequiredErrorMessage = t('emailRequiredErrorMessage')
  const emailInvalidErrorMessage = t('emailInvalidErrorMessage')
  const emailSpecialCharactersErrorMessage = t('emailSpecialCharactersErrorMessage')
  const phoneRequiredErrorMessage = t('phoneRequiredErrorMessage') || 'Phone number is required'
  const phoneInvalidErrorMessage = t('phoneInvalidErrorMessage') || 'Please enter a valid phone number'

  return ({
    email: z.string({
      required_error: emailRequiredErrorMessage
    })
      .email({
        message: (
          <div style={{ lineHeight: '1.5' }}>
            {emailInvalidErrorMessage} <br />
            {emailSpecialCharactersErrorMessage}
          </div>
        )
      })
      .refine((value) => {
        const dotRules = /^[^.].*[^.]$/;
        const consecutiveDotsRule = !/\.\./.test(value);
        const specialCharRule = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value);

        return dotRules.test(value) && consecutiveDotsRule && specialCharRule;
      }, {
        message: (
          <div style={{ lineHeight: '1.5' }}>
            {emailInvalidErrorMessage} <br />
            {emailSpecialCharactersErrorMessage}
          </div>
        )
      }),
    phone: z.string({
      required_error: phoneRequiredErrorMessage
    })
      .min(10, { message: phoneInvalidErrorMessage })
      .refine((value) => /^\d{10}$/.test(value), {
        message: phoneInvalidErrorMessage
      })
  })
}

export default validationschema